import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { useDispatch } from "react-redux";
import { makeProfileData } from "../../actions/storage";

import api from "../../actions/api";
import Spinner from '../Spinner';
import { generateUrl } from '../../helpers/media';
import { showToast } from '../../helpers/notify';
import { imageFileExtensions } from '../../helpers/media';

const detectType = (value) => {
    if (get(value, "file") instanceof File) {
        return "file";
    }
    else if (typeof value === "string") {
        return "id";
    }
    return "object";
}

const validate = (file, formats, sizelimit) => {
    const ext = extension(file.name);
    let fileAttr = {
        name: file.name,
        orgname: file.name,
        size: file.size,
        fa: ''
    }
    let data = {};
    if (formats !== "*" && !formats.includes(ext)) {
        data = {
            valid: false,
            reason: file.name + ' is invalid. Please upload a valid file',
            file: fileAttr
        }
    }
    else if (file.size > sizelimit * 1024 * 1024) {
        data = {
            valid: false,
            reason: 'Please upload a file of size less than ' + sizelimit + 'MB',
            file: fileAttr
        }
    }
    else {
        data = {
            valid: true,
            reason: "Success",
            file: fileAttr
        }
    }
    return data;
}

const extension = (name) => {
    var ext = name.substr((name.lastIndexOf('.') + 1));
    return ext.toLowerCase();
}

function UploadFile({ value = null, onRemove = () => null, formats = imageFileExtensions(), sizelimit = 1, onUpload, hideIcon = false, multiple = false }) {
    const [data, setData] = useState(value);
    const dispatch = useDispatch();

    const upload = () => {
        const file = get(value, 'file', {});
        const validation = validate(file, formats, sizelimit);

        if (get(validation, 'valid', false)) {
            var fd = new FormData();
            fd.append('file', file);
            fd.append('fileobject', true);
            api.post('/account/image', fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                let status = get(response, "status", 400);
                if (status === 200) {
                    setData(response.data);
                    onUpload(response.data, value);
                    dispatch(makeProfileData(response.data));
                }
                else {
                    uploadError("Error in uploading file.");
                }
            }).catch((error) => {
                setData({});
                const errors = get(error, "response.data.message", "Error in uploading file.");
                showToast(errors);
            })
        }
        else {
            showToast(validation.reason);
            uploadError(validation.reason);
        }
    }

    const fetchData = () => {
        if (value !== "") {
            api.get(`/media/${value}`).then((response) => {
                let status = get(response, "status", 400);
                if (status === 200) {
                    setData(response.data);
                }
                else {
                    uploadError("Error in fetching file.");
                }
            });
        }
    }

    const uploadError = () => {
        onRemove(value);
    }

    useEffect(() => {
        const actionFile = (type) => {
            if (type === "file") {
                upload();
            }
            else if (type === "id") {
                fetchData();
            }
        }
        actionFile(detectType(value));
        // eslint-disable-next-line
    }, [value]);

    if (!value) {
        return null
    }

    return (
        <div className="w-40 pt-5">
            {
                !data && (
                    <Spinner />
                )
            }
            {
                (data && data.name) && (
                    <div className={`${hideIcon ? 'border-none' : 'relative border overflow-x-auto border-gray-600 text-center'}`}>
                        <img alt='img' src={generateUrl(data, "316x0")} className={`w-40 h-40 ${hideIcon && 'rounded-full'} object-contain bg-[#F6F6F6]`} />
                    </div>
                )
            }
        </div>
    );
}

export default UploadFile;